import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TankLocation } from './../../_models/machinaries/tankLocation';
import { environment } from '../../../../environments/environment';
import { MachineLocation } from '../../_models/machinaries/machineLocation';
import { SilosLocation } from '../../_models/machinaries/silosLocation';
import { ToolLocation } from '../../_models/machinaries/toolLocation';

@Injectable()
export class MachineLocationService {
  private apiBaseUrl = environment.apiBaseUrl;
  private telemetryServiceUrl = environment.telemetryServiceUrl;

  constructor(private http: HttpClient) {}

  getMachineLocation(
    equipmentId,
    dataList: boolean,
    metricsList: boolean,
    startDate,
    endDate,
    externalSource,
    externalId = null
  ): Observable<Array<MachineLocation>> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/equipmentTelemetry/getEquipmentLocations?equipmentId=' +
          equipmentId +
          '&dataList=' +
          dataList +
          '&metricsList=' +
          metricsList +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate +
          (externalSource != null ? '&externalSource=' + externalSource : '') +
          (externalId != null ? '&externalId=' + externalId : '')
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getTankLocation(
    equipmentId,
    dataList: boolean,
    metricsList: boolean,
    startDate,
    endDate,
    externalSource
  ): Observable<Array<TankLocation>> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/equipmentTelemetry/getEquipmentLocations?equipmentId=' +
          equipmentId +
          '&dataList=' +
          dataList +
          '&metricsList=' +
          metricsList +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate +
          '&externalSource=' +
          externalSource
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getSilosLocation(
    equipmentId,
    dataList: boolean,
    metricsList: boolean,
    startDate,
    endDate,
    externalSource
  ): Observable<Array<SilosLocation>> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/equipmentTelemetry/getEquipmentLocations?equipmentId=' +
          equipmentId +
          '&dataList=' +
          dataList +
          '&metricsList=' +
          metricsList +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate +
          '&externalSource=' +
          externalSource
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getToolLocation(
    equipmentId,
    dataList: boolean,
    metricsList: boolean,
    startDate,
    endDate,
    externalSource,
    externalId = null
  ): Observable<Array<ToolLocation>> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/equipmentTelemetry/getEquipmentLocations?equipmentId=' +
          equipmentId +
          '&dataList=' +
          dataList +
          '&metricsList=' +
          metricsList +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate +
          (externalSource != null ? '&externalSource=' + externalSource : '') +
          (externalId != null ? '&externalId=' + externalId : '')
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  geLocationByEquipmentType(
    equipmentId,
    dataList: boolean,
    metricsList: boolean,
    startDate,
    endDate,
    type,
    externalSource,
    externalId = null
  ): Observable<any> {
    let result: Observable<any>;
    switch (type) {
      case 'tank_fixed':
      case 'tank_mobile':
        result = this.getTankLocation(
          equipmentId,
          dataList,
          metricsList,
          startDate,
          endDate,
          externalSource
        );
        break;
      case 'silos':
        result = this.getSilosLocation(
          equipmentId,
          dataList,
          metricsList,
          startDate,
          endDate,
          externalSource
        );
        break;
      case 'tractor':
        result = this.getMachineLocation(
          equipmentId,
          dataList,
          metricsList,
          startDate,
          endDate,
          externalSource,
          externalId
        );
        break;
      default: //if is not one of the previous is a tool
        result = this.getToolLocation(
          equipmentId,
          dataList,
          metricsList,
          startDate,
          endDate,
          externalSource,
          externalId
        );
    }
    return result;
  }

  getLastEquipmentLocation(id, externalSource, externalId): Observable<Array<MachineLocation>> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/equipmentTelemetry/getLastEquipmentLocations?equipmentId=' +
          id +
          '&externalSource=' +
          externalSource +
          '&externalId=' +
          externalId
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getEquipmentLocation(
    equipmentId,
    dataList: boolean,
    metricsList: boolean,
    startDate,
    endDate,
    externalSource,
    externalId,
    searchType,
    taskDataRef,
    keys = [],
    onlyActivity = false,
    activityIdList = []
  ): Observable<any> {
    const DDISearchInput = { ddiFilter: [] };
    keys.forEach((k) => {
      DDISearchInput.ddiFilter.push({ key: k.key, deviceElement: k.deviceElement });
    });
    if (searchType == 'report') {
      if (onlyActivity == false) {
        return this.http
          .post(
            this.telemetryServiceUrl +
              'api/equipmentTelemetry/getEquipmentLocations?equipmentId=' +
              equipmentId +
              '&fromXFarmClient=true' +
              '&dataList=' +
              dataList +
              '&metricsList=' +
              metricsList +
              '&startDate=' +
              startDate +
              '&endDate=' +
              endDate +
              (externalSource != null ? '&externalSource=' + externalSource : '') +
              (externalId != null ? '&externalId=' + externalId : ''),
            DDISearchInput
          )
          .pipe(
            map((response) => {
              return response;
            })
          );
      } else {
        let actIdsString = '';
        if (onlyActivity == true) {
          activityIdList.forEach((i) => {
            actIdsString = actIdsString + '&fieldActivityIds=' + i;
          });
        }
        return this.http
          .post(
            this.telemetryServiceUrl +
              'api/equipmentTelemetry/getEquipmentLocationsByFieldActivityIds?equipmentId=' +
              equipmentId +
              '&fromXFarmClient=true' +
              '&dataList=' +
              dataList +
              '&metricsList=' +
              metricsList +
              // + '&startDate=' + startDate
              // + '&endDate=' + endDate
              actIdsString +
              (externalSource != null ? '&externalSource=' + externalSource : '') +
              (externalId != null ? '&externalId=' + externalId : ''),
            DDISearchInput
          )
          .pipe(
            map((response) => {
              return response;
            })
          );
      }
    } else {
      const taskDataRefs = [];
      taskDataRef.forEach((tdr) => {
        taskDataRefs.push(tdr.itemName);
      });
      return this.http
        .post(
          this.telemetryServiceUrl +
            'api/equipmentTelemetry/taskData/equipmentLocations?equipmentId=' +
            equipmentId +
            '&dataList=' +
            dataList +
            '&metricsList=' +
            metricsList +
            (externalSource != null ? '&externalSource=' + externalSource : '') +
            (externalId != null ? '&externalId=' + externalId : ''),
          { taskDataRefs, ddiFilter: DDISearchInput.ddiFilter }
        )
        .pipe(
          map((response) => {
            return response;
          })
        );
    }
  }

  getInfoDataParameter(
    equipmentId,
    startDate,
    endDate,
    externalSource,
    externalId,
    searchType,
    taskDataRef
  ) {
    if (searchType == 'report') {
      return this.http
        .get<any>(
          this.telemetryServiceUrl +
            'api/equipmentTelemetry/getInfoDataParameter?equipmentId=' +
            equipmentId +
            '&fromXFarmClient=true' +
            '&startDate=' +
            startDate +
            '&endDate=' +
            endDate +
            (externalSource != null ? '&externalSource=' + externalSource : '') +
            (externalId != null ? '&externalId=' + externalId : '')
        )
        .pipe(
          map((response) => {
            return response;
          })
        );
    } else {
      const taskDataRefs = [];
      taskDataRef.forEach((tdr) => {
        taskDataRefs.push(tdr.itemName);
      });
      return this.http
        .post(
          this.telemetryServiceUrl +
            'api/equipmentTelemetry/taskData/getInfoDataParameter?equipmentId=' +
            equipmentId +
            '&fromXFarmClient=true' +
            (externalSource != null ? '&externalSource=' + externalSource : '') +
            (externalId != null ? '&externalId=' + externalId : ''),
          { taskDataRefs }
        )
        .pipe(
          map((response) => {
            return response;
          })
        );
    }
  }

  getEquipmentConnected(equipmentId, startDate, endDate, externalSource, externalId) {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/equipmentTelemetry/getEquipmentConnected?equipmentId=' +
          equipmentId +
          '&startDate=' +
          startDate +
          '&endDate=' +
          endDate +
          (externalSource != null ? '&externalSource=' + externalSource : '') +
          (externalId != null ? '&externalId=' + externalId : '')
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getSpecificLocation(date, latitude, longitude, externalSource, externalId) {
    return this.http
      .get<any>(
        this.telemetryServiceUrl +
          'api/equipmentTelemetry/getEquipmentLocation?date=' +
          date +
          '&externalId=' +
          externalId +
          '&externalSource=' +
          externalSource +
          '&latitude=' +
          latitude +
          '&longitude=' +
          longitude
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getEquipmentLocationFlattened(
    equipmentId,
    startDate,
    endDate,
    externalSource,
    externalId,
    searchType,
    taskDataRef
  ): Observable<any> {
    if (searchType == 'report') {
      return this.http
        .get<any>(
          this.telemetryServiceUrl +
            'api/equipmentTelemetry/equipmentLocations/flattened?equipmentId=' +
            equipmentId +
            '&fromXFarmClient=true' +
            '&startDate=' +
            startDate +
            '&endDate=' +
            endDate +
            (externalSource != null ? '&externalSource=' + externalSource : '') +
            (externalId != null ? '&externalId=' + externalId : '')
        )
        .pipe(
          map((response) => {
            return response;
          })
        );
    } else {
      const taskDataRefs = [];
      taskDataRef.forEach((tdr) => {
        taskDataRefs.push(tdr.itemName);
      });
      return this.http
        .post(
          this.telemetryServiceUrl +
            'api/equipmentTelemetry/taskData/equipmentLocations/flattened?equipmentId=' +
            equipmentId +
            '&fromXFarmClient=true' +
            (externalSource != null ? '&externalSource=' + externalSource : '') +
            (externalId != null ? '&externalId=' + externalId : ''),
          { taskDataRefs }
        )
        .pipe(
          map((response) => {
            return response;
          })
        );
    }
  }
}
